import React from 'react';
import PropTypes from 'prop-types';

const Remove = ({ width, height, color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 15.75 18">
    <path id="Path_2787" d="M15.187-14.625H10.969l-.33-.657a.923.923,0,0,0-.755-.468H5.861a.911.911,0,0,0-.749.468l-.33.657H.562A.563.563,0,0,0,0-14.062v1.125a.563.563,0,0,0,.562.562H15.187a.563.563,0,0,0,.562-.562v-1.125A.563.563,0,0,0,15.187-14.625ZM1.87.668A1.71,1.71,0,0,0,3.554,2.25H12.2A1.71,1.71,0,0,0,13.88.668l.745-11.918H1.125Z" transform="translate(0 15.75)" fill={color} />
  </svg>
);

Remove.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
};

Remove.defaultProps = {
  width: 15.75,
  height: 18,
  color: '#000',
};

export default Remove;
